import { cineamoApiClient } from '../../apiClient';
import { TicketPurchaseIntentDto } from '../../models/ticket-purchase-intent/TicketPurchaseIntentDto';
import { TicketPurchaseIntentInputDto } from '../../models/ticket-purchase-intent/TicketPurchaseIntentInputDto.types';
import { ApiResponse } from '../../types/ApiResponse.types';

// <------------------------ Create Ticket Purchase Intent ------------------------>

/**
 * This endpoint creates a Ticket Purchase Intent Dto.
 *
 * @example
 * createTicketPurchaseIntent({...data});
 *
 * @param data
 * @returns {ApiResponse<TicketPurchaseIntentDto>} rejects with the `ApiError` on a non-2xx
 */

export function createTicketPurchaseIntent(
    data: TicketPurchaseIntentInputDto
): Promise<ApiResponse<TicketPurchaseIntentDto>> {
    return cineamoApiClient
        .post<ApiResponse<TicketPurchaseIntentDto>>('/ticket-purchase-intents', data)
        .then((res) => res.data);
}
